export const MEASUREMENT_PROTOCOL_STATES = {
  NOT_STARTED: 'NOT STARTED',
  STARTED: 'STARTED',
  FINISHED: 'FINISHED',
} as const;

export const CUSTOMER_TYPE_OPTIONS = {
  PRIVATE: 116,
  BUSINESS: 117,
} as const;

export const NEIGHBOR_DISTANCE_KEPT_OPTIONS = {
  YES: 'YES',
  NO_CUSTOMER_BEARS_RISK: 'NO_CUSTOMER_BEARS_RISK',
  NO_ABORT_PROCESS: 'NO_ABORT_PROCESS',
} as const;

export const RECKONING_TYPE_OPTIONS = {
  ANNUAL: 'ANNUAL',
  MONTHLY: 'MONTHLY',
} as const;

export const ROOF_COVERING_OPTIONS = {
  TILES: 'TILES',
  TRAPEZOIDAL_SHEET: 'TRAPEZOIDAL_SHEET',
  PREFA: 'PREFA',
  ICOPAL: 'ICOPAL',
  OTHER: 'OTHER',
  METAL: 'METAL',
  SHINGLES_BITUMEN_FOIL: 'SHINGLES_BITUMEN_FOIL',
  THERMO_ROOF: 'THERMO_ROOF',
  CORRUGATED: 'CORRUGATED',
  // lookup
  HOHLPFANNE: 'HOHLPFANNE',
  PAPPDOCKEN: 'PAPPDOCKEN',
  SCHIEFER: 'SCHIEFER',
  SONDERDACH: 'SONDERDACH',
} as const;

export const ROOF_COVERING_MATERIAL_OPTIONS = {
  ALUMINUM: 'ALUMINUM',
  STEEL: 'STEEL',
  COPPER: 'COPPER',
  ZINC: 'ZINC',
};

export const ROOF_COVERING_SPECIFIC_TYPE_OPTIONS = {
  CORRUGATED: 'CORRUGATED',
  TRAPEZOIDAL: 'TRAPEZOIDAL',
  ANGLED_STANDING_SEAM: 'ANGLED_STANDING_SEAM',
  DOUBLE_STANDING_SEAM: 'DOUBLE_STANDING_SEAM',
  ROUND_SEAM: 'ROUND_SEAM',
  SCHARE: 'SCHARE',
  SHINGLES: 'SHINGLES',
  OTHER: 'OTHER',
};

export const ROOF_COVERING_TRAPEZOIDAL_MATERIAL_SIZE = {
  ALUMINUM_LARGE: 'ALUMINUM_LARGE',
  STEEL_LARGE: 'STEEL_LARGE',
  STEEL_SMALL: 'STEEL_SMALL',
  ALUMINUM_SMALL: 'ALUMINUM_SMALL',
} as const;

export const FLAT_ROOF_COVERING_OPTIONS = {
  BITUMEN: 'BITUMEN',
  GRAVEL_OR_GREEN_AREA: 'GRAVEL_OR_GREEN_AREA',
  TRAPEZOIDAL_SHEET: 'TRAPEZOIDAL_SHEET',
  PREFA: 'PREFA',
  ICOPAL: 'ICOPAL',
  OTHER: 'OTHER',
  FOIL: 'FOIL',
  METAL_SHEET: 'METAL_SHEET',
  // lookup
  HOHLPFANNE: 'HOHLPFANNE',
  PAPPDOCKEN: 'PAPPDOCKEN',
  SCHIEFER: 'SCHIEFER',
} as const;

export const DC_CABLE_ROUTING_OPTIONS = {
  ROOF_COVERING: 'ROOF_COVERING',
  EXTERIOR_FACADE: 'EXTERIOR_FACADE',
} as const;

export const ROOF_TRUSS_BEAM_MATERIAL_OPTIONS = {
  WOOD: 'WOOD',
  METAL: 'METAL',
  OTHER: 'OTHER',
} as const;

export const ROOF_COVERING_TILES_LOOSE_OPTIONS = {
  YES: 'YES',
  NO: 'NO',
  NOT_APPARENT: 'NOT_APPARENT',
} as const;

export const ROOF_TILE_ATTACHMENT = {
  MORTAR: 'MORTAR',
  CLAMP: 'CLAMP',
  GLUED: 'GLUED',
  CARDBOARD_DOCK: 'CARDBOARD_DOCK',
  SLATE: 'SLATE',
  PANTILE: 'PANTILE',
} as const;

export const ENERGY_FLOOR_OPTIONS = {
  FIRST_FLOOR: 'FIRST_FLOOR',
  SECOND_FLOOR: 'SECOND_FLOOR',
  THIRD_FLOOR: 'THIRD_FLOOR',
  BASEMENT: 'BASEMENT',
} as const;

export const ENERGY_STORAGE_LOCATION_REQUIREMENTS_OPTIONS = {
  YES_STANDING_AND_ON_WALL: 'YES_STANDING_AND_ON_WALL',
  YES_ONLY_ON_WALL: 'YES_ONLY_ON_WALL',
  YES_ONLY_STANDING: 'YES_ONLY_STANDING',
  NO: 'NO',
} as const;

export const ENERGY_STORAGE_AND_METER_DISTANCE_ROOM_OPTIONS = {
  SAME_ROOM: 'SAME_ROOM',
  ONE_OR_TWO_ROOMS_APART: 'ONE_OR_TWO_ROOMS_APART',
  MORE_THAN_TWO_ROOMS_APART: 'MORE_THAN_TWO_ROOMS_APART',
} as const;

export const EQUIPOTENTIAL_BONDING_RAIL_EXIST_OPTIONS = {
  YES: 'YES',
  NO: 'NO',
  NOT_APPARENT: 'NOT_APPARENT',
} as const;

export const SMART_HOME_OPTIONS = {
  NOT_INTERESTED: 'NOT_INTERESTED',
  HEATER_ONLY: 'HEATER_ONLY',
  UNDERFLOOR_HEATING_ONLY: 'UNDERFLOOR_HEATING_ONLY',
  HEATER_AND_UNDERFLOOR_HEATING: 'HEATER_AND_UNDERFLOOR_HEATING',
} as const;

export const LOCATION_OPTIONS = {
  AT_HOUSE: 'AT_HOUSE',
  INSIDE_HOUSE: 'INSIDE_HOUSE',
  AT_PROPERTY_BORDER: 'AT_PROPERTY_BORDER',
} as const;

export const CABLE_ROUTING_TYPE_OPTIONS = {
  UNDERGROUND_CABLE: 'UNDERGROUND_CABLE',
  OVERHEAD_LINE: 'OVERHEAD_LINE',
} as const;

export const ROOF_TYPE = {
  FLAT: 'FLAT',
  PITCHED: 'PITCHED',
} as const;

export const FIELD_TYPE = {
  TEXT: 'TEXT',
  NUMBER: 'NUMBER',
  ENUM: 'ENUM',
  BOOLEAN: 'BOOLEAN',
  VISUAL_DOCUMENTATION: 'VISUAL_DOCUMENTATION',
  OBJECT: 'OBJECT',
  SELECT: 'SELECT',
  DATE: 'DATE',
  YES_NO_BOOLEAN: 'YES_NO_BOOLEAN',
} as const;

export const MEASUREMENT_PROTOCOL_NUMBER_PROPERTIES = [
  'additional_energy_sub_meters_count',
  'energy_meters_count',
  'power_inverter_count',
  'power_inverter_output',
  'existing_photovoltaic_system_peak_output',
  'windows_count',
  'heaters_count',
  'valves_count',
  'heating_circuit_distributors_count',
  'room_controllers_count',
  'property_desired_pv_output_kwp',
  'distance_wallbox_energy_meter_cabinet',
  'buildings_count',
  'house_connection_boxes_count',
];

export const MEASUREMENT_PROTOCOL_ROOF_NUMBER_PROPERTIES = [
  'roof_tile_coverage',
  'roof_tile_width',
  'distance_ground_gutter',
  'parapet_width',
  'parapet_height',
  'roof_truss_beam_distance',
  'roof_truss_beam_width',
  'roof_truss_beam_height',
  'distance_to_main_building',
];

export const MEASUREMENT_PROTOCOL_METER_NUMBER_PROPERTIES = [
  'additional_household_power_kw',
  'business_power_kw',
  'heat_pump_power_kw',
  'instantaneous_water_heater_power_kw',
  'wallbox_power_kw',
];

export const GROUNDING_IMPLEMENTATION_OPTIONS = {
  BY_EKD: 'BY_EKD',
  BY_CUSTOMER: 'BY_CUSTOMER',
} as const;

export const POWER_CONNECTION_TYPE_OPTIONS = {
  HAK: 'HAK',
  HAS: 'HAS',
  ZAS: 'ZAS',
  TRANSFORMER_STATION: 'TRANSFORMER_STATION',
} as const;

export const ROOF_MORTARED_OPTIONS = {
  YES_WHOLE: 'YES_WHOLE',
  YES_RIDGE: 'YES_RIDGE',
  NO: 'NO',
} as const;

export const METER_HANDLING_METHOD_OPTIONS = {
  REMAIN: 'REMAIN',
  REMOVAL: 'REMOVAL',
  REMOVAL_AND_SUB_METER: 'REMOVAL_AND_SUB_METER',
} as const;

export const ELECTRICITY_CONTRACT_OWNER = {
  CUSTOMER: 'CUSTOMER',
  NOT_CUSTOMER: 'NOT_CUSTOMER',
} as const;

export const POWER_CONNECTION_LOCATION = {
  AT_BUILDING: 'AT_BUILDING',
  AT_PROPERTY_BORDER: 'AT_PROPERTY_BORDER',
} as const;

export const HAK_METER_CABINET_CABLE_PATH = {
  SURFACE: 'SURFACE',
  FLUSH_MOUNTED: 'FLUSH_MOUNTED',
} as const;

export const HAK_LOCATION = {
  AT_HOUSE: 'AT_HOUSE',
  IN_HOUSE: 'IN_HOUSE',
} as const;

export const MARKET_DATA_REGISTER_EXECUTOR = {
  CUSTOMER: 'CUSTOMER',
  EKD: 'EKD',
} as const;

export const NETWORK_CONNECTIVITY = {
  BAR_4: 'BAR_4',
  BAR_3: 'BAR_3',
  BAR_2: 'BAR_2',
  BAR_1: 'BAR_1',
  NO_NETWORK: 'NO_NETWORK',
} as const;

export const BACKUP_POWER_PACKAGE = {
  CREDIT: 'CREDIT',
  RESERVE_ENERGY_AND_CREDIT: 'RESERVE_ENERGY_AND_CREDIT',
} as const;

export const POWER_CONNECTION_RESPONSIBILITY = {
  PLANT_OPERATOR: 'PLANT_OPERATOR',
  EKD: 'EKD',
} as const;

export const PROPER_GROUNDING_EXISTS = {
  YES: 'YES',
  NO: 'NO',
} as const;

export const DC_EXPERT_FIELDS_STATUS = {
  NOT_REQUIRED: 'NOT_REQUIRED',
  REQUIRED: 'REQUIRED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
} as const;

export const DC_EXPERT_TASK_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
};

export const TaskType = {
  AS_PLANNING_CHANGE: 'AS_PLANNING_CHANGE',
  AS_PLANNING_PRIO: 'AS_PLANNING_PRIO',
  AS_PLANNING_NEW_BUILDING: 'AS_PLANNING_NEW_BUILDING',
  MP_DC_EXPERT: 'MP_DC_EXPERT',
};
